import { ReactNode } from 'react';
import { cn } from '@/helpers/classnames';

interface MainProps {
  children: ReactNode;
  className?: string;
}

export const FilteredListContainer = ({ children, className }: MainProps) => {
  return (
    <div
      className={cn(
        'flex min-h-0 grow flex-col md:flex-row-reverse lg:mb-0',
        className,
      )}
    >
      {children}
    </div>
  );
};
